// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"F3-z","dimensionLabel":"G3-z","styleChooserControlWrapper":"H3-z","styleChooserControl":"I3-z","disabled":"J3-z","giftCard":"K3-z","styleChooserText":"L3-z"};